import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { LocalInterfaceService } from '../../../services/local-inteface-service/local-interface.service';
import { ToastrService } from 'ngx-toastr';
import { ValidationService } from '../../../services/validation-service/validation.service';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from '../../../services/storege-service/storage.service';

@Component({
  selector: 'app-tournament-category',
  templateUrl: './tournament-category.component.html',
  styleUrls: ['./tournament-category.component.scss']
})
export class TournamentCategoryComponent implements OnInit {
  public isLoading: boolean = false;
  public tournamentID = '';
  public selectedRecordForEdit: any = '';

  categoryListingData?;
  facilityCcy: string = '';

  public totalRecords = 0;
  currentPage: number = 1;
  totalPages: number = 1;
  pageLimit: number = 10
  totalPageLimits: number[] = [5, 10, 20]
  categoriesList: string[] = ['A', 'B', 'C', 'D', 'E', 'M', 'WA', 'WB', 'WC', 'WD', 'WE', 'W', 'MX', 'U14', 'U16', 'U18'];

  @ViewChild('addNewCategoryModal', { static: false }) public addNewCategoryModal: ModalDirective;
  @ViewChild('removeCategoryModal', { static: false }) public removeCategoryModal: ModalDirective;


  categoryDetails: FormGroup
  constructor(
    private fb: FormBuilder,
    private localInterfaceSrv: LocalInterfaceService,
    private toastr: ToastrService,
    private validationSrv: ValidationService,
    public router: Router,
    public route: ActivatedRoute,
    private elementRef: ElementRef,
    private storageSrv: StorageService,
  ) {
  }

  ngOnInit(): void {
    this.validationSrv.validateAcess().then(async () => {
      // this.createForm();
      const tournamentID = this.route.snapshot.params['id'];
      this.tournamentID = tournamentID
      this.facilityCcy = this.storageSrv.getFacilityCcy();
      this.isLoading = true
      await this.loadCategoryListingData();
      this.isLoading = false
    });
    // this.createForm();
  }

  scrollToTop() {
    const htmlElement = this.elementRef.nativeElement.ownerDocument.documentElement;
    htmlElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  loadCategoryListingData = (updatedPage?, updatedLimit?) => {
    const obj = {
      // status: "current",

      page: updatedPage || this.currentPage,
      limit: updatedLimit || this.pageLimit,
    }

    const params = new URLSearchParams(obj as any);
    const queryString = params.toString();
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.tournamentID

      this.localInterfaceSrv.getTournamentCategoryList(queryString, this.tournamentID)
        .then(async res => {

          this.totalPages = res.data.count
          if (this.totalRecords <= 0) {
            this.totalRecords = res.data.count
          }

          this.categoryListingData = { content: res.data.content, count: this.totalRecords };
          this.isLoading = false;
          resolve(res);
        })
        .catch(err => {
          reject(err);
          console.log(err);

        })
        .finally(() => {
          this.isLoading = false
        });
    });
  }

  onPaginationChange = async (page: number) => {
    this.currentPage = page;
    // this.filterQuery=""
    this.scrollToTop()

    await this.loadCategoryListingData(page)
  }

  onPageChange = async (updatedPage) => {
    if (updatedPage === this.pageLimit)
      return

    this.pageLimit = updatedPage
    this.currentPage = 1;
    await this.loadCategoryListingData(1, updatedPage)
  }

  createForm(selectedRecord?): void {
    this.categoryDetails = this.fb.group({
      category: [selectedRecord ? selectedRecord.category : "", Validators.required],
      labelEn: [selectedRecord ? selectedRecord.labelEn : "", Validators.required],
      labelAr: [selectedRecord ? selectedRecord.labelAr : "", Validators.required],
      ccy: [selectedRecord ? selectedRecord.ccy : this.facilityCcy, Validators.required],
      totalSeats: [selectedRecord ? selectedRecord.totalSeats : "", [Validators.required, Validators.pattern(/^\d+$/)],],
      availableSeats: [selectedRecord ? selectedRecord.availableSeats : "", [Validators.required, Validators.pattern(/^\d+$/)],],
      price: [selectedRecord ? selectedRecord.price : "", [Validators.required, Validators.pattern(/^\d+$/)],],
      sort: [selectedRecord ? selectedRecord.sort : "", [Validators.required, Validators.pattern(/^\d+$/)],],
    });
  }

  addCategory = () => {
    this.createForm();
    this.addNewCategoryModal.show();

  }

  onEditCategoryClick = (item) => {
    console.log('Item', item);
    this.selectedRecordForEdit = item
    this.createForm(item);
    this.addNewCategoryModal.show();
  }

  onSubmit(): void {

    if (this.categoryDetails.valid) {
      console.log(this.categoryDetails);
      if (this.selectedRecordForEdit)
        this.updateTournamentCategoryData()
      else
        this.saveTournamentCategoryData();


    } else {
      // Form is invalid, show error messages
      this.markFormGroupTouched(this.categoryDetails);
    }
  }


  saveTournamentCategoryData = () => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv
        .saveTournamentCategory(this.categoryDetails.value, this.tournamentID)
        .then(async (res) => {
          this.toastr.success('Tournament Category saved successfully');
          this.addNewCategoryModal.hide();
          await this.loadCategoryListingData();

          this.isLoading = false;

          resolve(res);
        })
        .catch((err) => {
          reject(err);
          console.log(err);
          this.toastr.error(err.description, 'Error');
        })
        .finally(() => {
          this.isLoading = false;
        });
    });
  };

  updateTournamentCategoryData = () => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv
        .updateTournamentCategory(this.categoryDetails.value, this.tournamentID, this.selectedRecordForEdit.id)
        .then(async (res) => {

          this.toastr.success('Tournament Category Updated successfully');
          this.addNewCategoryModal.hide();
          await this.loadCategoryListingData(this.pageLimit, this.currentPage);

          this.isLoading = false;

          resolve(res);
        })
        .catch((err) => {
          reject(err);
          console.log(err);
          this.toastr.error(err.description, 'Error');
        })
        .finally(() => {
          this.isLoading = false;
        });
    });
  };

  markFormGroupTouched(formGroup: FormGroup): void {
    (Object as any).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }

  removeCategory = (selectedRecordForDelete) => {

    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;

      this.localInterfaceSrv
        .deleteTournamentCategory(this.tournamentID, selectedRecordForDelete)
        .then(async (res) => {

          this.toastr.success('Tournament Category Deleted successfully');
          this.removeCategoryModal.hide();
          await this.loadCategoryListingData();

          this.isLoading = false;

          resolve(res);
        })
        .catch((err) => {
          reject(err);
          console.log(err);
          this.toastr.error(err.description, 'Error');
        })
        .finally(() => {
          this.isLoading = false;
        });
    });
  }

  onModalHide() {
    console.log('Modal closed');
    // Your logic here
  }
}
